module.exports = __webpack_public_path__ + "img/image2.7e471f9b.png";